<template>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center row wrap>
          <v-flex sm12 md6 lg4>
            <fcc-login />
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
</template>

<script>
  import FCCLogin from './components/FCCLogin'

  export default {
    data: () => ({
      drawer: null,
    }),
    props: {
      source: String
    },
    components: {
      "fcc-login": FCCLogin,
    }
  }
</script>